<template>
  <wow-card elevation="0" :show-title="false">
    <v-data-table
      dense
      :headers="headers"
      :items="orderDetailsList"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.wowKitOrderQuantity="{item}">
        <div v-if="item.wowKitOrderQuantity > item.quantity" class="custom-cell green darken-1 white--text">{{ item.wowKitOrderQuantity }}</div>
        <div v-else-if="item.quantity > item.wowKitOrderQuantity" class="custom-cell red darken-1 white--text">{{ item.wowKitOrderQuantity }}</div>
        <div v-else>{{ item.wowKitOrderQuantity }}</div>
      </template>
    </v-data-table>
    <v-row
      v-if="(WOWKIT_MAKER && rejectReasonText !== '' && rejectReasonText) ||
      (WOWKIT_ZSM_APPROVED && rejectReasonText !== '' && rejectReasonText) ||
      (WOWKIT_APPROVED && rejectReasonText !== '' && rejectReasonText)"
    >
      <v-col cols="12" md="4" offset-md="8" lg="4" offset-lg="8" sm="6" offset-sm="6">
        <wow-reject :disabled="WOWKIT_MAKER || WOWKIT_ZSM_APPROVED || WOWKIT_APPROVED" outlined v-model="rejectReasonText" :rejectEmail="rejectedBy"></wow-reject>
      </v-col>
    </v-row>
    <v-card-actions v-if="showApproveReject" class="d-flex justify-end">
      <v-btn @click="approveOrderInitiate('Approve')" class="success" small>
        <v-icon small>mdi-check</v-icon>
        <span class="ml-1">Approve</span>
      </v-btn>
      <v-btn @click="openRejectReasonPopup" small class="error">
        <v-icon small>mdi-block-helper</v-icon>
        <span class="ml-1">Reject</span>
      </v-btn>
    </v-card-actions>
    <wow-dialog :fullscreen="false" :title="`Rejection Reason`" v-model="rejectResonDialog" :persistent="true"
      @close="closeRejectReasonDialog" width="600">
      <v-card>
        <v-card-text>
          <wow-reject outlined v-model="rejectReason" :disabled="WOWKIT_MAKER" :hideDetails="true"
            :rejectedBy="false"></wow-reject>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn @click="rejectOrderInitiated('Reject')" small class="error">
            <v-icon small>mdi-block-helper</v-icon>
            <span class="ml-1">Reject</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </wow-dialog>
  </wow-card>
</template>
<script>
import _ from 'lodash'
import Utils from '@/utils'
import CONSTANTS from '@/utils/constants'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import WowReject from '@/components/Orders/WowKitOrdering/kitComponents/reason/rejectReason'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
export default {
  name: 'viewOrderDetails',
  props: {
    orderObj: {
      type: Object,
      default: () => { }
    },
    WOWKIT_ZSM_APPROVED: {
      type: Boolean,
      default: false
    },
    WOWKIT_APPROVED: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WowCard,
    WowReject,
    WowDialog
  },
  data () {
    return {
      headers: [
        { text: 'FCID', value: 'productID', sortable: true },
        { text: 'BOM Quantity', value: 'quantity', sortable: true },
        { text: 'BOQ Quantity', value: 'wowKitOrderQuantity', sortable: true },
        { text: 'Comment', value: 'reason', sortable: true }
      ],
      orderDetailsList: [],
      rejectReason: '',
      rejectReasonText: '',
      rejectedBy: null,
      franchiseeId: null,
      modelId: null,
      showApproveReject: false,
      approverType: null,
      approverLevel: null,
      rejectResonDialog: false,
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER')
    }
  },
  created: async function () {
    // if (this.WOWKIT_ZSM_APPROVED || this.WOWKIT_APPROVED) {
    //   this.showApproveReject = true
    //   this.approverType = this.WOWKIT_ZSM_APPROVED ? CONSTANTS.WOW_KIT_APPROVER.zmApprove : CONSTANTS.WOW_KIT_APPROVER.approved
    //   if ((CONSTANTS.WOW_KIT_APPROVER.zmApprove !== this.approverType) && CONSTANTS.WOW_KIT_APPROVER.approved !== this.approverType) {
    //     this.showApproveReject = false
    //   }
    //   this.approverLevel = this.WOWKIT_ZSM_APPROVED ? 'level1' : 'level2'
    // } else {
    //   this.showApproveReject = false
    //   this.approverType = null
    // }
    this.showApproveReject = false
    this.approverType = null
    if (this.WOWKIT_ZSM_APPROVED && this.orderObj.approvalStatus === CONSTANTS.WOW_KIT_APPROVER.pending) {
      this.showApproveReject = true
      this.approverLevel = 'level1'
      this.approverType = CONSTANTS.WOW_KIT_APPROVER.zmApprove
    }
    if (this.WOWKIT_APPROVED && this.orderObj.approvalStatus === CONSTANTS.WOW_KIT_APPROVER.zmApprove) {
      this.showApproveReject = true
      this.approverLevel = 'level2'
      this.approverType = CONSTANTS.WOW_KIT_APPROVER.approved
    }
    await this.getitemsDetails()
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    openRejectReasonPopup: function () {
      this.rejectReason = ''
      this.rejectResonDialog = true
    },
    closeRejectReasonDialog: function () {
      this.rejectResonDialog = false
    },
    getitemsDetails: async function () {
      try {
        const res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/ordering-viewDetails?InitatedOrdersID=${this.orderObj.id}`)
        if (res.status === 200) {
          this.orderDetailsList = res.data.rows
          this.rejectReasonText = res.data.rejectionData.rejectionReason
          this.rejectedBy = res.data.rejectionData.rejectedBy
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    approveOrderInitiate: async function (status) {
      this.$emit('refreshList', false)
      this.$dialog.confirm({
        title: 'Approve Order',
        text: 'Are you sure you want to <b>approve</b> the order?',
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let payload = {}
                payload.initiateOrderID = this.orderObj.id
                payload.approverLevel = this.approverLevel
                payload.status = this.approverType
                const res = await http.put(`${CONSTANTS.API_URL}/api/wow-kit/edit-initaitedOrders-status`, payload)
                if (res.status === 200) {
                  this.okMsg(res.data)
                  this.$emit('close')
                  this.$emit('refreshList', true)
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    },
    rejectOrderInitiated: async function (status) {
      try {
        this.$emit('refreshList', false)
        let payload = {}
        payload.initiateOrderID = this.orderObj.id
        payload.approverLevel = this.approverLevel
        if (status === 'Reject' && _.isEmpty(this.rejectReason.trim())) {
          return this.$dialog.error({
            text: 'Rejection reason is mandatory for rejecting any entry',
            title: 'Error'
          })
        }
        payload.status = CONSTANTS.WOW_KIT_APPROVER.rejected
        payload.reason = this.rejectReason.trim()
        const res = await http.put(`${CONSTANTS.API_URL}/api/wow-kit/edit-initaitedOrders-status`, payload)
        if (res.status === 200) {
          this.okMsg(res.data)
          this.$emit('close')
          this.$emit('refreshList', true)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    }
  }
}
</script>
<style>
div.custom-cell{
  height:32px;
  padding: 0px 16px;
  display:flex;
  align-items: center;
}
td:has(> div.custom-cell) {
  padding:0px!important;
}
</style>
